module.exports = __webpack_public_path__ + "static/media/timer.c3f34abe.svg";